webpackJsonp([3],{

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(488),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(18);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FilterProduct: __WEBPACK_IMPORTED_MODULE_3__components__["l" /* FilterProduct */],
    NewProducts: __WEBPACK_IMPORTED_MODULE_3__components__["m" /* NewProducts */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])("products", {
    products: "items",
    pagination: "pagination"
  }), {
    quickSearch: {
      get: function get() {
        return this.quickSearchFilter;
      },
      set: function set(val) {
        this.quickSearchFilter = val;
      }
    }
  }),
  data: function data() {
    return {
      search: "",
      searchVm: {
        contains: {
          name: "",
          shapeId: "",
          dimensionId: ''
        },
        between: {
          unitPrice: {
            former: 0,
            latter: 0
          }
        }
      },
      query: "",
      quickSearchFilter: "",
      shapeId: '',
      dimensionId: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: "Sản phẩm"
    };
  },
  mounted: function mounted() {
    this.getItems();
    this.$store.dispatch("appinfo/setTitle", 'Sản phẩm');
  },

  methods: {
    print: function print() {
      window.print();
    },
    edit: function edit(item) {
      this.$router.push({
        name: "Product",
        params: { id: item.Id }
      });
    },
    searchProducts: function searchProducts() {
      this.query = "shapeId=" + this.searchVm.contains.shapeId + "&dimensionId=" + this.searchVm.contains.dimensionId;
      Store.dispatch("products/searchProducts", this.query, this.pagination);
    },
    getItems: function getItems() {
      this.query = "";
      this.quickSearch = "";
      Store.dispatch("products/getItems", {
        query: this.quickSearchFilter.toLowerCase(),
        pagination: this.pagination
      });
    },
    selectAttribute: function selectAttribute(shapeId, dimensionId) {
      this.searchVm.contains.shapeId = shapeId;
      this.searchVm.contains.dimensionId = dimensionId;
      this.searchProducts();
    },
    selectShape: function selectShape(id) {
      this.searchVm.contains.shapeId = id;
      this.searchProducts();
    },
    selectDimension: function selectDimension(id) {
      this.searchVm.contains.dimensionId = id;
      this.searchProducts();
    },
    cancelSearch: function cancelSearch() {
      this.rightDrawer = false;
    },

    quickSearchProducts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      console.log(this.quickSearchFilter);
      this.quickSearchFilter && Store.dispatch("products/quickSearch", {
        headers: this.headers,
        qsFilter: this.quickSearchFilter.toLowerCase(),
        pagination: this.pagination
      });
    }, 300)
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-full-width"
  }, [_c('div', {
    staticClass: "section-boxed"
  }, [_c('div', {
    staticClass: "portfolio-carousel"
  }, [_vm._m(0), _vm._v(" "), _c('FilterProduct', {
    on: {
      "selectShape": _vm.selectShape,
      "selectDimension": _vm.selectDimension
    }
  }), _vm._v(" "), _c('new-products', {
    attrs: {
      "items": _vm.products,
      "maxHeight": 200
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-header"
  }, [_c('div', {
    staticClass: "carousel-title"
  }, [_c('h4', {
    staticClass: "small-title"
  }, [_vm._v("Danh sách sản phẩm")]), _vm._v(" "), _c('a', {
    staticClass: "link-title",
    attrs: {
      "href": "/products"
    }
  }, [_c('span', {
    staticClass: "more-arrow"
  }, [_vm._v("›")])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// assets/js/3.7e7666b27ea21ce9380e.js